import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth } from "../../firebase/config";
import { onAuthStateChanged } from "firebase/auth";
import Chat from "./Chat";

const ChatWrapper = ({ userProfile }) => {
  const { conversationId } = useParams();
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <p>Loading chat...</p>;
  if (!currentUser) return <p>Please log in to view messages</p>;

  return (
    <Chat
      conversationId={conversationId}
      currentUser={currentUser}
      userProfile={userProfile}
    />
  );
};

export default ChatWrapper;
